'use strict';

var ChartClassFareFilterFactory = function ChartClassFareFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['SchedulesFilterByMonthsFactory', 'MarketsFilterByPOSFactory', 'MarketsFilterByMarketFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ChartClassFareFilter() {
    DemandFilter.call(this, 'market-dashboard', ['dashboard-class-fare', 'dashboard-panel', 'dashboard-alerts-panel'], 2);
    this.registerFilters(injectedFilters);
  }
  ChartClassFareFilter.prototype = Object.create(DemandFilter.prototype);
  ChartClassFareFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) !== -1;
  };
  return ChartClassFareFilter;
};
ChartClassFareFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ChartClassFareFilterFactory;